import { Component } from 'react';
import { Helmet } from 'react-helmet';

class Meta extends Component {
  render() {
    const {
      title,
      description = 'Default description',
      keywords = 'react, seo, react-helmet',
      author = 'Your Name',
    } = this.props;

    return (
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <meta name="author" content={author} />

        
      </Helmet>
    );
  }
}

export default Meta;
